module.exports = __webpack_public_path__ + "img/franchise-certificate.1b5e9aba.svg";